(function ($) {
  'use strict';

  this.TDF2023 = function () {};
}).bind(window)(jQuery);
